import React from 'react';

const SidebarBlock = ({ title, children, tone = 'default' }) => {
  const toneClasses =
    tone === 'highlight'
      ? 'border-amber-200 bg-amber-50'
      : tone === 'dark'
      ? 'border-slate-800 bg-slate-900 text-white'
      : 'border-slate-200 bg-white';

  return (
    <section className={`rounded-xl border p-4 ${toneClasses}`}>
      <div className="mb-3 border-b border-current/15 pb-2">
        <h3 className="text-xs font-black uppercase tracking-widest">{title}</h3>
      </div>
      {children}
    </section>
  );
};

export default SidebarBlock;
